// src/pages/NewsPage.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Subpage from "../components/Subpage";
import { slugOrId } from "../utils/slugOrId";
import { Heart, MessageCircle, Eye } from "lucide-react";
import { API_BASE, mediaUrl } from "../utils/apiBase";
import { BRAND_NAME } from "../components/BrandName";

export default function NewsPage() {
  const [newsPosts, setNewsPosts] = useState([]);

  useEffect(() => {
  axios
    .get(`${API_BASE}/news-items`, {
      params: {
        sort: "createdAt:desc",
        "fields[0]": "Title",
        "fields[1]": "slug",
        "fields[2]": "views",
        "fields[3]": "PublishDate",
        "populate[Sections][populate]": "Media",
        "populate[Tags]": true,
      },
    })
    .then((res) => setNewsPosts(res.data.data))
    .catch((err) => console.error("Error fetching news:", err));
}, []);



  return (
    <Subpage
      title="NEWS"
      content={`Explore the latest updates, devlogs, and announcements from ${BRAND_NAME}.`}
      relatedLinks={[]}
    >
      {newsPosts.length ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-24">
          {newsPosts.map((post) => {
            if (!post.Title) return null;

            const excerpt =
              post.Sections
                ?.find(
                  (block) =>
                    block.Type === "text" && Array.isArray(block.TextContent)
                )
                ?.TextContent?.[0]?.children?.[0]?.text?.slice(0, 150) + "…";

            const thumb = post.Sections?.flatMap(
              (section) => section.Media || []
            )
              .map((img) => img?.url || img?.attributes?.url)
              .filter(Boolean)[0];

            return (
              <Link
              to={`/news/${slugOrId(post)}`}
                key={post.documentId}
                className="relative rounded-md overflow-hidden shadow-lg transition-transform duration-300 hover:scale-[1.02]"
              >
                {thumb && typeof thumb === "string" && (
                  <img
                    src={mediaUrl(thumb)}
                    alt={post.Title}
                    className="w-full h-48 object-cover"
                  />
                )}

                {/* TAGS – absolute block in top-right */}
                {Array.isArray(post.Tags) && post.Tags.length > 0 && (
                   <div className="absolute top-3 right-3 flex flex-wrap gap-2 z-10">
                     {post.Tags.map((t, i) => {
                      /* Strapi v4: t might be a string or an object */
                      const label =
                       typeof t === "string"
                       ? t
                       : t?.Name || t?.name || t?.attributes?.Name;
                       if (!label) return null;
                       return (
                        <span
                        key={i}
                         className="
                         px-2 py-0.5 rounded-full
                         text-[10px] font-semibold uppercase tracking-wide
                         text-white
                         bg-[#872341]/90
                         backdrop-blur-sm
                         "
                        >
                           {label}
                        </span> 
                         );
                        })}
                   </div>
                     )}

                <div className="p-5 space-y-2">
                  {post.PublishDate && (
                    <p className="text-xs text-gray-500 uppercase tracking-wide">
                      {new Date(post.PublishDate).toLocaleDateString(undefined, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </p>
                  )}
                  <h3 className="text-lg font-semibold text-gray-900 line-clamp-2">
                    {post.Title}
                  </h3>
                  {excerpt && (
                    <p className="text-sm text-gray-600 line-clamp-3">
                      {excerpt}
                    </p>
                  )}
                </div>

                {/* Social metrics (bottom-right) */}
                <div className="absolute bottom-3 right-3 flex gap-4 z-10 text-sm text-black/80">
                  {/*
                  <span className="flex items-center gap-1">
                    <Heart className="w-4 h-4" /> {post.likes || 0}
                  </span>
                  <span className="flex items-center gap-1">
                    <MessageCircle className="w-4 h-4" /> 0
                  </span>
                  */}
                  <span className="flex items-center gap-1">
                    <Eye className="w-4 h-4" />
                    {post.views ?? post.attributes?.views ?? 0}
                  </span>
                </div>

              </Link>
            );
          })}
        </div>
      ) : (
        <p>No news available.</p>
      )}
    </Subpage>
  );
}
